import { nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue'

type Options = {
  max: () => number
  itemCount: () => number
  isClipped: (container: HTMLElement) => boolean
}

export const useFitItemsToContainer = (
  getContainer: () => HTMLElement | null,
  { max, itemCount, isClipped }: Options,
) => {
  const visibleCount = ref(max())

  const recompute = async () => {
    visibleCount.value = Math.min(max(), itemCount())
    await nextTick()
    const el = getContainer()
    if (!el) {
      return
    }
    while (visibleCount.value > 0 && isClipped(el)) {
      visibleCount.value -= 1
      await nextTick()
    }
  }

  let observer: ResizeObserver | undefined
  onMounted(() => {
    void recompute()
    const el = getContainer()
    if (!el || typeof ResizeObserver === 'undefined') {
      return
    }
    observer = new ResizeObserver(() => void recompute())
    observer.observe(el)
    if (el.parentElement) {
      observer.observe(el.parentElement)
    }
  })
  onBeforeUnmount(() => observer?.disconnect())

  watch([max, itemCount], () => void recompute())

  return { visibleCount }
}
